import { motion } from "motion/react";
import { useTranslation } from "react-i18next";

export default function ERPDiagram() {
  const { t } = useTranslation();
  const areas = t('about.erp_architecture.areas', { returnObjects: true }) as string[];

  return (
    <section className="py-24 bg-surface-container-low border-y border-outline-variant scroll-mt-20">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="mb-16 text-center">
          <h2 className="text-3xl md:text-4xl font-bold text-on-surface mb-4">{t('about.erp_architecture.title')}</h2>
          <p className="text-on-surface-variant max-w-xl mx-auto">{t('about.erp_architecture.subtitle')}</p>
        </div>

        <div className="relative flex flex-col items-center gap-8">
          {/* Core */}
          <motion.div
            initial={{ scale: 0.8, opacity: 0 }}
            whileInView={{ scale: 1, opacity: 1 }}
            viewport={{ once: true }}
            className="w-40 h-40 bg-primary-container rounded-full flex items-center justify-center shadow-xl z-10"
          >
            <span className="text-white font-bold text-lg text-center leading-tight">{t('about.erp_architecture.core')}</span>
          </motion.div>

          {/* Business areas grid */}
          <div className="grid grid-cols-2 md:grid-cols-3 gap-4 w-full max-w-3xl">
            {areas.map((area, idx) => (
              <motion.div
                key={idx}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: idx * 0.1 }}
                className="bg-white border border-outline-variant p-5 rounded-xl text-center hover:border-primary-container transition-all"
              >
                <span className="font-bold text-on-surface">{area}</span>
              </motion.div>
            ))}
          </div>

          {/* Connector lines (CSS) */}
          <div className="absolute top-[160px] left-1/2 -translate-x-1/2 w-0.5 h-8 bg-outline-variant hidden lg:block" />

          {/* Description */}
          <motion.p
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            className="text-on-surface-variant text-center max-w-2xl leading-relaxed mt-4"
          >
            {t('about.erp_architecture.description')}
          </motion.p>
        </div>
      </div>
    </section>
  );
}
